// ImpastoSection.jsx
import { motion } from "framer-motion";

export default function ImpastoSection() {

    return (
        <section className="relative bg-background overflow-hidden py-24 px-6">
            {/* Decorazione sfumata */}
            <div className="absolute inset-0 bg-gradient-to-br from-black via-black/80 to-background z-0" />

            {/* Container */}
            <div className="relative max-w-6xl mx-auto z-10 flex flex-col lg:flex-row items-center gap-12">
                {/* Video */}
                <motion.div
                    className="w-full lg:w-1/2 rounded-2xl overflow-hidden shadow-2xl"
                    initial={{ opacity: 0, y: 40 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.8 }}
                >
                    <div className="aspect-video relative group">
                        <video
                            muted
                            autoPlay
                            loop
                            playsInline
                            className="w-full h-full object-cover brightness-110 transition rounded-[20px] duration-300 border-2 border-primary"
                        >
                            <source
                                src="/videos/impasto.web"
                                type="video/webm"
                            />
                            <source
                                src="/videos/impasto.mp4"
                                type="video/mp4"
                            />
                        </video>
                    </div>
                </motion.div>

                {/* Testo */}
                <motion.div
                    className="w-full lg:w-1/2 text-left"
                    initial={{ x: 40, opacity: 0 }}
                    whileInView={{ x: 0, opacity: 1 }}
                    viewport={{ once: true }}
                    transition={{ duration: 0.6 }}
                >
                    <h2 className="text-3xl md:text-4xl font-title text-primary mb-4 leading-tight">
                        Il nostro impasto artigianale
                    </h2>
                    <p className="text-muted text-base md:text-lg leading-relaxed mb-4">
                        Il nostro impasto è realizzato con farina di grano tenero Casillo con germe di grano, che aggiunge valore nutrizionale e un tocco di sapore più intenso. Inoltre, subisce una maturazione in cella di 24 ore, che consente allo sviluppo di un sapore più complesso e una texture più ariosa. L'impasto è idratato al 70%, il che significa che contiene una quantità ottimale di acqua per creare una crosta croccante e un interno soffice.
                    </p>
                    <p className="text-muted text-base md:text-lg leading-relaxed">
                        Il risultato è una pizza con un sapore unico e ad alta digeribilità.
                    </p>
                </motion.div>
            </div>
        </section>
    );
}
